import { Dispatch, SetStateAction } from 'react';
import { PriorityItemDto } from '../../../api';
import Popup from '../../Popup';
import PriorityForm from '../../../pages/admin/PriorityForm';
import PriorityQueries from '../../../pages/admin/PriorityQueries';
import { Employee } from '../../../models/Employee';

interface IUpdatePriorityDialogProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  priority: PriorityItemDto;
  employee?: Employee;
  showEmployeeDropdown?: boolean;
}

function UpdatePriorityPopup(props: IUpdatePriorityDialogProps) {
  const { isOpen, setIsOpen, priority, employee, showEmployeeDropdown } = props;
  const { mutateUpdatePriority } = PriorityQueries();
  const popupTitle = employee ? `Update Priority for ${employee.firstName} ${employee.lastName}` : 'Update Priority';

  return (
    <Popup title={popupTitle} openPopup={isOpen} setOpenPopup={setIsOpen}>
      <PriorityForm
        employee={employee}
        order={priority.order}
        priority={priority}
        onSubmit={(priority: PriorityItemDto) => {
          mutateUpdatePriority(priority, {
            onSuccess: () => setIsOpen(false),
          });
        }}
        onCancel={() => setIsOpen(false)}
        showEmployeeDropdown={showEmployeeDropdown}
      />
    </Popup>
  );
}

export default UpdatePriorityPopup;
